<div class="sentriaccess-stepper" #sentriAccessStepper>
	<div class="step-container">
		@for (step of steps; track step; let i = $index) {
			<div class="step">
				<div
					[ngClass]="{ 'active-step-number': currentStep === i, 'previous-step-number': i < currentStep }"
					class="step-number step-text-attributes"
				>
					@if (currentStep <= i) {
						<p class="previous-step-number-p">{{ i + 1 }}</p>
					}
					@if (i < currentStep) {
						<mat-icon svgIcon="sl-check" class="previous-step-number-icon"></mat-icon>
					}
				</div>
				<div
					[ngClass]="{ 'active-step-label': currentStep === i, 'previous-step-label': i < currentStep }"
					class="step-label step-text-attributes"
				>
					{{ step }}
				</div>
				@if (i < currentStep) {
					<div class="line-dash-container">
						<hr class="line-dash-prev" />
					</div>
				}
				@if (i !== steps.length - 1 && currentStep <= i) {
					<div class="line-dash-container">
						<hr [ngClass]="{ 'active-step-dash': currentStep === i }" class="line-dash first-dash" />
						<hr [ngClass]="{ 'active-step-dash': currentStep === i }" class="line-dash second-dash" />
						<hr [ngClass]="{ 'active-step-dash': currentStep === i }" class="line-dash third-dash" />
						<hr [ngClass]="{ 'active-step-dash': currentStep === i }" class="line-dash fourth-dash" />
					</div>
				}
			</div>
		}
	</div>
</div>
